module.exports = __webpack_public_path__ + "img/78.937acd28.webp";